// src/context/AuthContext.js
import React, { createContext, useEffect, useState } from "react";
import { SESSIONTIMEOUT } from "../constant";

// Create a Context for authentication
const AuthContext = createContext();

// Create a Provider component
const AuthProvider = ({ children }) => {
  const SESSION_TIMEOUT = SESSIONTIMEOUT
  const [user, setUser] = useState(null); // Store login details here
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    const loginTimestamp = localStorage.getItem("loginTimestamp");
    if (storedUser && loginTimestamp) {
      const elapsed = Date.now() - parseInt(loginTimestamp, 10);
      if (elapsed > SESSION_TIMEOUT) {
        logout();
      } else {
        setUser(JSON.parse(storedUser));
        startSessionTimeout(SESSION_TIMEOUT - elapsed);
      }
    }
    setLoading(false);
  }, []);

  const login = (userDetails) => {
    const timestamp = Date.now();
    // console.log(userDetails, "ip");
    setUser(JSON.parse(userDetails));
    localStorage.setItem("user", userDetails);
    localStorage.setItem("loginTimestamp", timestamp.toString());
    startSessionTimeout(SESSION_TIMEOUT);
  };
  // console.log(user, 'ds');

  const logout = () => {
    // Simulate logout
    setUser(null);
    localStorage.removeItem("user"); // Remove user from localStorage
    localStorage.removeItem("loginTimestamp");
    // navigate("/login");
  };
  const startSessionTimeout = (timeoutDuration) => {
    setTimeout(() => {
      alert("Session has expired. Please log in again.");
      logout();
    }, timeoutDuration);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export { AuthContext, AuthProvider };
